export const openGoogleAuthPopup = (
  authLink,
  dispatch,
  saveGmailDraft,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'GoogleAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(saveGmailDraft({ templateId, authCode }));

            showSuccessMessage(
              'Your email template has been successfully drafted in Gmail!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openOutlookWebAuthPopup = (
  authLink,
  dispatch,
  saveMailchimpDraft,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'OutlookWebAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(saveMailchimpDraft({ templateId, authCode }));

            showSuccessMessage(
              'Your email template has been successfully drafted in Outlook!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openMailchimpAuthPopup = (
  authLink,
  dispatch,
  saveMailchimpDraft,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'MailchimpAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(saveMailchimpDraft({ templateId, authCode }));

            showSuccessMessage(
              'Your template has been successfully drafted in Mailchimp!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openZohoMailAuthPopup = (
  authLink,
  dispatch,
  saveZohoMailDraft,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
  zohoMailRegion,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'ZohoMailAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(
              saveZohoMailDraft({ templateId, authCode, zohoMailRegion }),
            );

            showSuccessMessage(
              'Your template has been successfully drafted in Zoho Mail!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openZohoCampaignAuthPopup = (
  authLink,
  dispatch,
  saveZohoCampaignDraft,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
  zohoCampaignRegion,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'ZohoCampaignAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(
              saveZohoCampaignDraft({
                templateId,
                authCode,
                zohoCampaignRegion,
              }),
            );

            showSuccessMessage(
              'Your template has been successfully drafted in Zoho Mail!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openConstantContactAuthPopup = (
  authLink,
  dispatch,
  exportToConstantContact,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'ConstantContactAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(exportToConstantContact({ templateId, authCode }));

            showSuccessMessage(
              'Your template has been successfully exported to Constant Contact!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};

export const openCleverReachAuthPopup = (
  authLink,
  dispatch,
  exportToCleverReach,
  templateId,
  showSuccessMessage,
  showErrorMessage,
  getErrorText,
  setIsLoading,
  setSelectedItem,
) => {
  const popupWidth = 600;
  const popupHeight = 600;
  const left = window.screenX + (window.outerWidth - popupWidth) / 2;
  const top = window.screenY + (window.outerHeight - popupHeight) / 2.5;

  // Open the popup
  const authPopup = window.open(
    authLink,
    'CleverReachAuth',
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`,
  );

  // Monitor the popup for URL changes
  const interval = setInterval(async () => {
    if (authPopup && authPopup.closed) {
      setIsLoading(false);
      setSelectedItem('');
      clearInterval(interval);
    }

    try {
      const popupUrl = authPopup.location.href;

      if (popupUrl.includes('code=')) {
        const urlParams = new URLSearchParams(new URL(popupUrl).search);
        const authCode = urlParams.get('code');

        if (authCode) {
          clearInterval(interval);

          try {
            await dispatch(exportToCleverReach({ templateId, authCode }));

            showSuccessMessage(
              'Your template has been successfully exported to CleverReach!',
            );
          } catch {
            showErrorMessage(getErrorText());
          } finally {
            authPopup.close();
            setIsLoading(false);
            setSelectedItem('');
          }
        }
      }
    } catch (err) {
      // Ignore CORS errors until the popup is redirected back to your domain
    }
  }, 500);
};
